import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, breakpoints } = redesignTheme;

export const useResourceSidebarStyles = makeStyles(() => ({
  sidebar: {
    display: 'none',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing.md,
      width: 216,
      flexShrink: 0,
      padding: `${spacing.sm}px 12px`,
      borderRadius: 4,
      border: `1px solid ${colors.surfaceBorder}`,
      backgroundColor: colors.surface,
      position: 'sticky',
      top: 88,
      alignSelf: 'flex-start',
    },
  },
  sidebarSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
  sidebarSectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
  },
  sidebarSectionLabel: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.base,
    color: colors.text,
    lineHeight: 1,
  },
  sidebarItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
  },
  sidebarItem: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    width: '100%',
    padding: spacing.xs,
    border: 0,
    borderRadius: 4,
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: colors.tabInactive,
    },
  },
  sidebarItemActive: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    width: '100%',
    padding: spacing.xs,
    border: 0,
    borderRadius: 4,
    backgroundColor: colors.tabInactive,
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: colors.iconSurface,
    },
  },
  sidebarItemLabel: {
    flex: 1,
    fontFamily: fonts.gothic,
    fontSize: fontSize.sm,
    color: colors.textSecondary,
    letterSpacing: 0.24,
    lineHeight: 1.4,
  },
  sidebarItemLabelActive: {
    flex: 1,
    fontFamily: fonts.gothic,
    fontSize: fontSize.sm,
    color: colors.text,
    letterSpacing: 0.24,
    lineHeight: 1.4,
  },
  countBadge: {
    position: 'relative',
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: colors.accentMuted,
    color: colors.textSecondary,
    flexShrink: 0,
    overflow: 'hidden',
  },
  countBadgeActive: {
    position: 'relative',
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: colors.brownDark,
    color: colors.background,
    flexShrink: 0,
    overflow: 'hidden',
  },
  countBadgeValue: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.xs,
    lineHeight: 1,
    letterSpacing: 0,
    color: 'inherit',
    whiteSpace: 'nowrap',
  },
}));
